const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_VARIANT)
const groupMultiplePrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL_VARIANTS)

export const apiMealVariant = {
	fetchDietMealVariant: async (variant: number) => {
		const { data } = await apiCommon<IDietMealVariant>(`${groupPrefix}/${variant}`, {
			method: 'GET',
			...createQuery(),
		})
		return { data: DietMealVariant(data) }
	},

	fetchDietMealMultipleVariants: async (
		ids?: number[],
		names?: string[],
		excludedIDs?: number[],
		date?: string,
		isActive?: boolean | null,
		productLine?: EProductLine,
	) => {
		const { data } = await apiCommon<IDietMealVariant[]>(groupMultiplePrefix, {
			method: 'GET',
			...createQuery(undefined, {
				id: ids,
				name: names,
				excluded_ids: excludedIDs,
				date: date ?? undefined,
				is_active: isActive,
				product_line: productLine,
			}),
		})
		return data.map(DietMealVariant)
	},
}
